import React from "react";
const SvgPhone = props => (
  <svg viewBox="0 0 12 17" {...props}>
    <path
      style={{
        stroke: "none",
        fill: "currentColor"
      }}
      fillRule="evenodd"
      d="M10.7 12.6l-.4-.3a21 21 0 01-1-.8c-.5-.4-1-.4-1.3 0l-.4.4-.4.1c-.3 0-1-.8-2.2-2.6a18.8 18.8 0 01-.8-1.3c-1-2-1.2-3-1-3.3l.2-.3.6-.1c.4-.1.7-.6.6-1L4.4 2v-.6c0-.4 0-.6-.2-.8a.8.8 0 00-.6-.5L1.3 0C1.1 0 .7.1.4.6c-.9 1.5-.4 5.8 1.7 9.5v.1c2.2 3.7 5.6 6.3 7.3 6.3.6 0 .8-.3 1-.5l1-2c.1-.2.1-.5 0-.8-.2-.3-.3-.4-.7-.6z"
    />
  </svg>
);
export default SvgPhone;
